// export const BACKEND_URL = process.env.REACT_APP_API_BASE_URL || "https://api1.sanoft.com/api";
export const BACKEND_URL = process.env.REACT_APP_API_BASE_URL || "https://api-pos-legacy-uat.sanoft.com/api";

export const ROUTES = {
  LOGIN: "/login",
  LOCK_SCREEN: "/lock",
  BILL_NUMBER: "/bill-number",
  SHIFT: "/shift",
  SELECT_SHOP: "/shops",
  COUNTER: "/counter",
  SALES: "/sales",
  ACTIVE_ORDERS: "/active-orders",
  TABLE_DASHBOARD: "/table-dashboard",
  REPORT: "/reports",
  PAYPAGE: "/payment",
  CUSTOMERS: "/customers",
  CUSTOMER_DETAILS: "/customers/:customerId",
  MANAGE: "/manage",
  CATEGORY: "/manage/category",
  PRODUCTS: "/manage/products",
  LABEL_SCALE: "/manage/servers/label-scale",
  SERVERS: "/manage/servers",
  KOT: "/manage/servers/kot",
  BLUETOOTH_SCALE: "/manage/servers/bluetooth-scale",
  SALESPERSON: "/manage/salesperson",
  PRINTERS: "manage/printers",
  SETTINGS: "/manage/settings",
  BILL_CURRENCY: "/manage/settings/bill&currency",
  FEATURES: "/manage/settings/features",
  TAX: "/manage/settings/tax",
  BASIC_INFO: "/manage/settings/basic-info",
  LICENCE_SETUP: "/setup-licence",
  PAYMENT_MODE: "/manage/payment-mode",
  ABOUT_US: "/manage/about-us",
  ERP_DASHBOARD: "/erp-dashboard",
  SUBSCRIPTION_EXPIRED: "/subscription-expired",
  PURCHASE: "/purchases",
  NEW_PURCHASE: "/purchases/new",
  EDIT_PURCHASE: "/purchases/edit/:purchaseId",
  DRAFT_PURCHASES: "/purchases/drafts",
  EDIT_DRAFT_PURCHASE: "/purchases/draft/edit/:draftId",
  STOCK_DAMAGES: "/stock-damages",
  DRAFT_STOCK_DAMAGES: "/stock-damages/drafts",
  ADD_STOCK_DAMAGE: "/stock-damages/add",
  VENDORS: "/vendors",
  VENDOR_DETAILS: "/vendors/:vendorId",
  ONLINE_ORDERS: "/online-orders",
};

export const API_PATH = {
  LOGOUT: "/logout/",
};

export const ROUTE_PREFIXES = {
  LOCAL_CUSTOMER: "L",
};

export const STORAGE_KEYS = {
  USER_AUTH_TOKEN: "pos-auth-token",
  TERMINAL_AUTH_TOKEN: "pos-terminal-auth-token",
  APP_VERSION: "pos-app-version",
  USER_ID: "pos-auth-user-id",
  SHOP_ID: "pos-selected-shop-id",
  USERNAME: "pos-username",
  USER_TYPE: "pos-user-type",
  SHOP_NAME: "pos-shop-name",
  BILL_NUMBER_PREFIX: "pos-bill-number-prefix",
  BILL_NUMBER_SUFFIX: "pos-bill-number-suffix",
  ESTIMATE_BILL_NUMBER_SUFFIX: "pos-estimate-bill-number-suffix",
  SHIFT: "pos-shift-name",
  SHIFT_ID: "pos-shift-id",
  ALL_SHIFTS: "pos-shifts",
  TERMINAL_ID: "pos-terminal-id",
  TERMINAL_NAME: "pos-terminal-name",
  TERMINAL: "pos-terminal",
  SALESPERSON_LOGIN: "pos-salesperson-login",
  TAX_PREFERENCE: "pos-tax-preference",
  TAX_REGION: "pos-tax-region",
  PAYMENT_MODES: "pos-payment-modes",
  PRINTER_TYPE: "pos-printer-type",
  SELECTED_PRINTER: "pos-selected-printer",
  INVOICE_FORMAT: "pos-invoice-format",
  QUEUE_KEY: "pos-network-printer-queue",
  SAVED_INVOICE: "pos-saved-invoices",
  SALESPERSONS: "pos-salespersons",
  SALESPERSON: "pos-salesperson",
  SALESPERSON_LOGGED_IN_TIME: "pos-salesperson-logged-in-time",
  PAYMENT_MODE_BALANCES: "payment-mode-balances",
  IS_ORDER_DASHBOARD_ENABLED: "pos-order-dashboard-enabled",
  IS_TABLE_DASHBOARD_ENABLED: "pos-table-dashboard-enabled",
  TABLE_DASHBOARD_ACTIVE_AREA: "pos-table-dashboard-active-area",
  LAST_ROUTE: "last-route",
  INVOICE_PRINTER_FORMAT: "pos-invoice-printer-format",
  NETWORK_IP: "pos-network-ip",
  ORDER_TYPES: "pos-order-types",
  TERMINAL_SETTINGS: "pos-terminal-settings",
  SHOP_PROFILE: "pos-shop-profile",
  LAST_PRODUCT_FETCH_TIME: "last-product-fetched-at",
  LAST_SALESPERSON_FETCH_TIME: "last-salesperson-fetched-at",
  LAST_TABLE_AREA_FETCH_TIME: "last-table-area-fetched-at",
  LAST_CUSTOMER_FETCH_TIME: "last-customer-fetch-time",
  INVOICE_TARGET_TYPE: "pos-invoice-target-type",
  INVOICE_TARGET_VALUE: "pos-invoice-target-value",
  SELECTED_CUSTOMER: "pos-selected-customer",
  EXPENSE_TYPES: "pos-expense-types",
  SHIFT_EXPIRY_SKIP_TIME: "pos-shift-expiry-skip-time",
  BATCH_BARCODE_CONFIG: "pos-batch-barcode-config",
  LAST_VENDOR_FETCH_TIME: "last-vendor-fetch-time",
  SHIFT_STATUS_KEY: "pos-shift-status",
  SHIFT_ENTERED_BALANCES: "pos-shift-entered-balances",
  CLOUD_SYNC_ENABLED: "pos-cloud-sync-enabled",
  NOTIFICATION_TOKEN: "pos-notification-token",
};

export const APP_VERSION = "1.0.73";

export const HEADERS = {
  AUTH: "Authorization",
  SHOP_ID: "shop-id",
  APP_VERSION: "App-Version",
};

export const CONTACT_NUMBER = "919567453182";

export const ORDER_TYPES = {
  DINE_IN: "DINE IN",
  TAKE_AWAY: "TAKE AWAY",
  DELIVERY: "DELIVERY",
  ONLINE: "ONLINE",
  NC: "NC",
};

export const DASHBOARD_OPTIONS = {
  ORDERS_DASHBOARD: "Orders Dashboard",
  TABLE_DASHBOARD: "Table Dashboard",
};

export const PRINTER_TYPES = {
  USB: "USB",
  BLUETOOTH: "BLUETOOTH",
  LAN: "LAN",
  DIRECT_USB: "DIRECT_USB",
};

export const PRINTER_RESPONSES = {
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};

export const INVOICE_PRINTER = {
  type: [PRINTER_TYPES.USB, PRINTER_TYPES.DIRECT_USB, PRINTER_TYPES.LAN],
  invoiceFormat: ["3 Inch", "3 Inch (Multi-language)", "3 Inch (Arabic)", "A4", "A5"],
  kotFomat: ["3 Inch", "3 Inch Large", "3 Inch (Multi-language)", "3 Inch (Arabic)", "A4"],
};

export const INVOICE_FORMATS = {
  THREE_INCH: "3 Inch",
  THREE_INCH_MULTI_LANGUAGE: "3 Inch (Multi-language)",
  THREE_INCH_MULTI_LANGUAGE_ARABIC: "3 Inch (Arabic)",
  A4: "A4",
  A5: "A5",
};

export const KOT_FORMAT = {
  THREE_INCH_KOT: "3 Inch",
  THREE_INCH_KOT_LARGE: "3 Inch Large",
  THREE_INCH_KOT_MULTI_LANGUAGE: "3 Inch (Multi-language)",
  THREE_INCH_KOT_MULTI_LANGUAGE_ARABIC: "3 Inch (Arabic)",
};

export const BARCODE_PRINTER = {
  type: [PRINTER_TYPES.USB, PRINTER_TYPES.DIRECT_USB, PRINTER_TYPES.BLUETOOTH, PRINTER_TYPES.LAN],
  barcodeFormat: ["38 X 25 [2 column]", "50 X 25"],
};

export const TAX_PREFERENCES = {
  INCLUDING_TAX: "Including Tax",
  EXCLUDING_TAX: "Excluding Tax",
  NO_TAX: "No Tax",
};

export const TAX_REGIONS = [
  { "United Arab Emirates": "UAE" },
  { "Saudi Arabia": "Saudi" },
  { Bahrain: "BH" },
  { Oman: "Oman" },
  { Malaysia: "MY" },
  { India: "India" },
];

export const TAX_TYPES = {
  GST: "GST",
  IGST: "IGST",
  VAT: "VAT",
  NO_TAX: null,
  TAX: "Tax",
};

export const AUTH_YTPE = {
  terminal: "TERMINAL",
  shop: "SHOP",
};

export const DISCOUNT_DISTRIBUTION = {
  SPREAD: "spread",
  NO_SPREAD: "no_spread",
};

export const SANOFT_LINKS = {
  WEB: "https://www.sanoft.com",
  PRIVACY_POLICY: "https://www.sanoft.com/privacy-policy",
  TERMS_AND_CONDITIONS: "https://www.sanoft.com/terms-and-conditions",
  REFUND_POLICY: "https://www.sanoft.com/refund-policy",
};

export const PRESET_NOTES = ["No sugar", "Less sugar", "Extra sugar", "No ice", "Less ice", "Extra ice"];
export const CUSTOM_PRODUCT_NOTES_KEY = "custom-product-notes";

export const APP_SETTING_KEYS = {
  BILL_NUMBER_PREFIX: "BILL_NUMBER_PREFIX",
  NEXT_BILL_NO: "NEXT_BILL_NO",
};

export const COLLECTIONS = {
  SALES: {
    name: "sales",
    keyPath: "local_id",
    autoIncrement: true,
    indexes: [{ name: "bill_no", keyPath: "bill_no", options: { unique: true } }],
  },
  SHIFT_TRANSACTIONS: { name: "shift_transactions", keyPath: "id", autoIncrement: true },
  SALESPERSONS: { name: "salespersons", keyPath: "id", autoIncrement: true },
  PRODUCTS: { name: "products", keyPath: "id", autoIncrement: true },
  CATEGORIES: { name: "categories", keyPath: "id", autoIncrement: true },
  APP_SETTINGS: { name: "app-settings", keyPath: "key", autoIncrement: false },
  TABLES: { name: "tables", keyPath: "id", autoIncrement: false },
  CUSTOMERS: { name: "customer", keyPath: "local_id", autoIncrement: true },
  CUSTOMER_GROUPS: { name: "customer_groups", keyPath: "local_id", autoIncrement: true },
  AREAS: { name: "areas", keyPath: "id", autoIncrement: false },
  PRICE_CATEGORIES: { name: "price_categories", keyPath: "id", autoIncrement: false },
  PRICE_CATEGORY_ITEMS: { name: "price_category_items", keyPath: "id", autoIncrement: false },
  ADDON_MAPPINGS: { name: "addon_mappings", keyPath: "id", autoIncrement: false },
  CHARGE_GROUPS: { name: "charge_groups", keyPath: "id", autoIncrement: false },
  CHARGES: { name: "charges", keyPath: "id", autoIncrement: false },
  DELETED_CARTS: { name: "deleted_carts", keyPath: "local_id", autoIncrement: true },
  STOCK_DAMAGES: { name: "stock_damages", keyPath: "local_id", autoIncrement: true },
  PURCHASES: { name: "purchases", keyPath: "local_id", autoIncrement: true },
  VENDORS: { name: "vendors", keyPath: "local_id", autoIncrement: true },
  EDITED_SALES: { name: "edited_sales", keyPath: "local_id", autoIncrement: true },
  CUSTOMER_PAYMENT_LOGS: { name: "customer_payment_logs", keyPath: "local_id", autoIncrement: true },
  CUSTOMER_JOURNALS: { name: "customer_journals", keyPath: "customerId", autoIncrement: false },
  PRINT_ERROR_JOBS: { name: "print_error_jobs", keyPath: "id", autoIncrement: true },
};

export const CUSTOMER_JOURNAL_TYPES = {
  PAYMENT: "payment",
  SALE: "sale",
};

export const SALE_STATUS = {
  DRAFT: "draft",
  PRINTED: "printed",
  VOID: "void",
  PAID: "paid",
  ACTIVE: "active",
  RETURNED: "returned",
  BUY_BACK: "buy-back",
};

export const DRAFT_STATUS = {
  SAVED: "saved",
  DRAFT: "draft",
};

export const DRAFT_SAVE_REASONS = {
  EMPTY_ITEMS: "EMPTY_ITEMS",
};

export const SALE_DIALOG_STATUS = {
  PROCESSING: "processing",
  SUCCESS: "success",
};

export const ONLINE_ORDER_STATUS = {
  ALL: "ALL",
  PENDING: "PENDING",
  PREPARING: "PREPARING",
  READY: "READY",
  DELIVERED: "DELIVERED",
  CANCELLED: "CANCELLED",
  REFUNDED: "REFUNDED",
};

export const ONLINE_ORDER_SOURCES = {
  SANOFT_CART: "sanoft-cart",
  SWIGGY: "swiggy",
  ZOMATO: "zomato",
  EXTERNAL_API: "external-api",
};

export const ONLINE_ORDER_SOURCE_LABELS = {
  [ONLINE_ORDER_SOURCES.SANOFT_CART]: "SANOFT CART",
  [ONLINE_ORDER_SOURCES.SWIGGY]: "SWIGGY",
  [ONLINE_ORDER_SOURCES.ZOMATO]: "ZOMATO",
  [ONLINE_ORDER_SOURCES.EXTERNAL_API]: "EXTERNAL",
};

export const ONLINE_PAYMENT_STATUS = {
  SUCCESS: "SUCCESS",
  PAID: "PAID",
  COMPLETED: "COMPLETED",
  PENDING: "PENDING",
  FAILED: "FAILED",
};

export const PAYMENT_STATUS = {
  PAID: "PAID",
  UNPAID: "UNPAID",
  PENDING: "PENDING",
  FAILED: "FAILED",
};

export const NOTIFICATION_TYPES = {
  NEW_ONLINE_ORDER: "new_online_order",
};

export const ONLINE_ORDER_FILTER_TABS = [
  { id: ONLINE_ORDER_STATUS.ALL, label: "All Orders" },
  { id: ONLINE_ORDER_STATUS.PENDING, label: "Pending" },
  { id: ONLINE_ORDER_STATUS.PREPARING, label: "Preparing" },
  { id: ONLINE_ORDER_STATUS.READY, label: "Ready" },
  { id: ONLINE_ORDER_STATUS.DELIVERED, label: "Delivered" },
];

export const KOT_STATUS = {
  DRAFT: "DRAFT",
  PENDING: "PENDING",
  PREPARING: "PREPARING",
  READY: "READY",
  DISPATCH: "DISPATCH",
};

export const KOT_STATUS_COLORS = {
  [KOT_STATUS.DRAFT]: "#9e9e9e",
  [KOT_STATUS.PENDING]: "#ff9800",
  [KOT_STATUS.PREPARING]: "#2196f3",
  [KOT_STATUS.READY]: "#4caf50",
  [KOT_STATUS.DISPATCH]: "#f44336",
};

export const ESTIMATE_STATUS_LABELS = {
  CONVERTED: "Converted to Sale",
};

export const SALE_SYNC_STATUS = {
  PENDING: "pending",
  SYNCED_TO_CLOUD: "synced",
  SYNCED_TO_LOCAL: "syncedToLocal",
  FAILED: "failed",
  UNSYNCED: "unsynced",
};

export const SHIFT_SYNC_STATUS = {
  PENDING: "pending",
  SYNCED: "synced",
  FAILED: "failed",
  PENDING_CREATE: "pending_create",
  PENDING_CLOSE: "pending_close",
};

export const KOT_MESSAGES = {
  FAILED: "Failed to process KOT",
  NO_CHANGES: "No changes to print",
};

export const SALE_INVOICE_TITLES = {
  DUPLICATE: "DUPLICATE",
};

export const KOT_TITLES = {
  REPRINT: "REPRINT KOT",
  CONSOLIDATED: "CONSOLIDATED KOT",
  CANCELLED: "CANCELLED",
  UPDATED_KOT: "UPDATED KOT",
  ADDON: "ADDON KOT",
  TABLE_CHANGED: "TABLE CHANGED",
};

export const KEYPAD_BUTTONS = {
  ONE: "1",
  TWO: "2",
  THREE: "3",
  FOUR: "4",
  FIVE: "5",
  SIX: "6",
  SEVEN: "7",
  EIGHT: "8",
  NINE: "9",
  ZERO: "0",
  DOT: ".",
  CLEAR: "C",
  BACKSPACE: "clear",
  DELETE: "Delete",
  PLUS_MINUS: "+/-",
  PLUS_TEN: "+10",
  PLUS_FIFTY: "+50",
  PLUS_HUNDERD: "+100",
  PLUS_TWO_HUNDERD: "+200",
  PLUS_FIVE_HUNDRED: "+500",
  PLUS_ONE_THOUSAND: "+1000",
};

export const INVOICE_HEADERS = {
  TAX_INVOICE: "TAX INVOICE",
  ESTIMATE: "ESTIMATE",
};

export const CURRENCY_OPTIONS = [
  { symbol: "₹", name: "Indian Rupee", fraction: "Paise" },
  { symbol: "Rs", name: "Indian Rupee", fraction: "Paise" },
  { symbol: "€", name: "Euro", fraction: "Cent" },
  { symbol: "£", name: "British Pound Sterling", fraction: "Pence" },
  { symbol: "C$", name: "Canadian Dollar", fraction: "Cent" },
  { symbol: "AED", name: "UAE Dirham", fraction: "Fils" },
  { symbol: "BHD", name: "Bahraini Dinar", fraction: "Fils" },
  { symbol: "KWD", name: "Kuwaiti Dinar", fraction: "Fils" },
  { symbol: "LKR", name: "Sri Lankan Rupee", fraction: "Cents" },
  { symbol: "MYR", name: "Malaysian Ringgit", fraction: "Sen" },
  { symbol: "OMR", name: "Omani Rial", fraction: "Baisa" },
  { symbol: "QAR", name: "Qatari Riyal", fraction: "Dirham" },
  { symbol: "SAR", name: "Saudi Riyal", fraction: "Halalah" },
  { symbol: "SGD", name: "Singapore Dollar", fraction: "Cent" },
  { symbol: "THB", name: "Thai Baht", fraction: "Satang" },
  { symbol: "USD", name: "US Dollar", fraction: "Cent" },
];

export const TOGGLE_OPTIONS = [
  { key: "showToken", label: "Show token number", description: "Display the unique token number on the invoice." },
  {
    key: "orderFullPayment",
    label: "Order with full payment only",
    description: "Allow order creation only after full payment is received.",
  },
  {
    key: "displayAwaitingDispatchOrders",
    label: "Display awaiting dispatch orders",
    description: "Display paid orders awaiting dispatch with a different color.",
  },
  {
    key: "autoReceiveFullAmount",
    label: "Auto receive full amount on Captain invoice",
    description: "Automatically mark orders from Captain app as paid using default payment method.",
  },
  // {
  //   key: "salespersonLogin",
  //   label: "Salesperson login",
  //   description: "Require salesperson credentials for POS access.",
  // },
  {
    key: "printOnPayment",
    label: "Print invoice on payment update",
    description: "Automatically print invoice after payment is updated.",
  },
  {
    key: "paymentModeOnInvoice",
    label: "Print payment mode on invoices",
    description: "Show selected payment method on the invoice.",
  },
  {
    key: "printMRP",
    label: "Print MRP on invoice",
    description: "Display Maximum Retail Price details on invoices.",
  },
  {
    key: "printHSN",
    label: "Print HSN on invoice",
    description: "Include HSN (Harmonized System of Nomenclature) code in invoices.",
  },
  {
    key: "printTotalSave",
    label: "Print total you save on invoice",
    description: "Show customer's total savings on the invoice.",
  },
  {
    key: "printPaymentQrOnInvoice",
    label: "Print payment QR on invoice",
    description: "Display payment QR code on the printed invoice.",
  },
  {
    key: "counterFoil",
    label: "Counter foil with invoice",
    description: "Print a detachable counter copy along with the invoice.",
  },
  {
    key: "amountFractions",
    label: "Amount with 3 fractions",
    description: "Display amounts with up to three decimal places.",
  },
  // {
  //   key: "confirmWeight",
  //   label: "Confirm weight",
  //   description: "Prompt to verify item weight before finalizing order.",
  // },
  // {
  //   key: "advancedQty",
  //   label: "Advanced quantity control",
  //   description: "Enable detailed quantity management features.",
  // },
  {
    key: "tableSelection",
    label: "Enable table selection on POS",
    description: "Select tables for dine-in orders directly from the POS.",
  },
  {
    key: "showItemChargesOnInvoice",
    label: "Show item charges on invoice",
    description: "Display individual item charges and discounts on the printed invoice.",
  },
  {
    key: "showItemsOnKotWhenTableChange",
    label: "Show items on KOT on table change",
    description: "Show items on KOT when changing table.",
  },
  {
    key: "salespersonLogin",
    label: "Enable salesperson login",
    description: "Enable salesperson login",
  },
  {
    key: "kotWithInvoice",
    label: "KOT with invoice",
    description: "Print the Kitchen Order Ticket together with the invoice.",
    hasIp: true,
  },
  {
    key: "consolidatedKOT",
    label: "Consolidated KOT",
    description: "Combine multiple kitchen orders into a single KOT print.",
    hasIp: true,
  },
];

export const TERMINAL_CONFIG_KEYS = [
  "consolidatedKOT",
  "autoReceiveFullAmount",
  "showItemChargesOnInvoice",
  "printPaymentQrOnInvoice",
  "displayAwaitingDispatchOrders",
  "showItemsOnKotWhenTableChange",
  "printHSN",
];

export const SYSTEM_VIEW = {
  POS: "pos",
  ERP: "erp",
};

export const PRODUCT_TYPE = {
  INVENTORY: "INVENTORY",
  SERVICE: "SERVICE",
  PRODUCTION: "PRODUCTION",
  COMBO: "COMBO",
};

export const PAYMENT_MODES = {
  CASH: "cash",
  UPI: "upi",
  GPAY: "Google pay",
  PHONEPAY: "Phone pay",
  CARD: "Card",
  DISCOUNT: "Discount",
  DISCOUNT_PERCENTAGE: "Discount %",
  CREDIT: "Credit",
  POINTS: "Points",
};

export const DEFAULT_PAYMENT_MODE_ORDER = {
  DISCOUNT: 996,
  DISCOUNT_PERCENTAGE: 997,
  CREDIT: 998,
  POINTS: 999,
};

export const SPECIAL_PAYMENT_MODE_ID = {
  DISCOUNT: -1,
  DEFAULT: -2,
  CREDIT: -3,
  DISCOUNT_PERCENTAGE: -4,
  POINTS: -5,
};

export const PAYMENT_MODE_ORDER_KEYS = {
  DISCOUNT: "discount",
  DISCOUNT_PERCENTAGE: "discount_percentage",
  CREDIT: "credit",
  POINTS: "points",
};

export const UPI_MODES = [PAYMENT_MODES.UPI, PAYMENT_MODES.GPAY, PAYMENT_MODES.PHONEPAY];

export const MEASURMENT_UNITS = {
  KG: "Kg",
  PCS: "Pcs",
  G: "g",
  LTR: "Ltr",
  ML: "Ml",
  M: "m",
  CM: "cm",
  FT: "ft",
  INCH: "Inch",
  UNIT: "Unit",
  BOX: "Box",
  SQ_METER: "m3",
  SQ_FOOT: "ft2",
  CARAT: "Carat",
  DOZEN: "Dozen",
  BUNCH: "Bunch",
};

export const PRINTER_COMMANDS = {
  OPEN_DRAWER: new Uint8Array([0x1b, 0x70, 0x00, 0x60, 0x60]),
  BEEP_SOUND: new Uint8Array([0x1b, 0x42, 0x03, 0x03]),
  CUT_CHARS: new Uint8Array([0x1d, 0x56, 0x00]),
  LINE_FEED: new Uint8Array([0x0a, 0x0a, 0x0a, 0x0a]),
  FEED_PAPER: new Uint8Array([0x1b, 0x64, 0x06]),

  CHARS_SIZE_NORMAL: new Uint8Array([0x1d, 0x21, 0x00]),
  CHARS_SIZE_DOUBLE: new Uint8Array([0x1d, 0x21, 0x11]),
  CHARS_SIZE_BOLD: new Uint8Array([0x1d, 0x21, 0x10]),

  ALIGN_LEFT: new Uint8Array([0x1b, 0x61, 0x00]),
  ALIGN_CENTER: new Uint8Array([0x1b, 0x61, 0x01]),
  ALIGN_RIGHT: new Uint8Array([0x1b, 0x61, 0x02]),

  INVERT_TEXT_ON: new Uint8Array([0x1d, 0x42, 0x01]),
  INVERT_TEXT_OFF: new Uint8Array([0x1d, 0x42, 0x00]),

  UNDERLINE_ON: new Uint8Array([0x1b, 0x2d, 0x01]),
  UNDERLINE_OFF: new Uint8Array([0x1b, 0x2d, 0x00]),
};

export const INVOICE_DISPLAY_OPTIONS = {
  ACTUAL_RATE: { value: "actual_rate", label: "Actual rate" },
  ACTUAL_RATE_PLUS_TAX: { value: "actual_rate_plus_tax", label: "Actual rate + Tax" },
  BASE_RATE: { value: "base_rate", label: "Base rate" },
  BASE_RATE_PLUS_TAX: { value: "base_rate_plus_tax", label: "Base rate + Tax" },
  PRICE: { value: "price", label: "Price" },
};

export const STOCK_CHECK_OPTIONS = {
  ALLOW_NEGATIVE_STOCK: { value: "allow_negative_stock", label: "Allow negative stock" },
  TERMINAL: { value: "terminal", label: "Terminal Verification" },
  ACROSS_SHOP: { value: "across_shop", label: "Across Shop Verification" },
};

export const ADD_TO_CART_OPTIONS = {
  APPEND: { value: "append", label: "Add to cart as append" },
  NEW_ITEM: { value: "new_item", label: "Add to cart as new item" },
};

export const KOT_SPLIT_OPTIONS = {
  KOT_SPLIT_BY_KITCHEN_NAME: { value: "splitByKitchenName", label: "Split by Kitchen" },
  KOT_SPLIT_BY_CATEGORY: { value: "splitByCategory", label: "Split by Category" },
  KOT_SPLIT_BY_ITEM: { value: "splitByItem", label: "Split by Item" },
  KOT_SPLIT_BY_ITEM_QTY: { value: "splitByItemQty", label: "Split by Item Quantity" },
};

export const INVOICE_ACTIONS = {
  DEFAULT: "DEFAULT",
  PRINT: "PRINT",
  SHARE: "SHARE",
  PRINT_AND_WHATSAPP: "PRINT_AND_WHATSAPP",
  SAVE_AND_WHATSAPP: "SAVE_AND_WHATSAPP",
  SAVE: "SAVE",
  PAYMENT: "PAYMENT",
  WITH_KOT: "WITH_KOT",
};

export const DEFAULT_INVOICE_ACTION_OPTIONS = {
  PRINT: { value: INVOICE_ACTIONS.PRINT, label: "Print Invoice" },
  SAVE: { value: INVOICE_ACTIONS.SAVE, label: "Save Invoice" },
  SAVE_AND_WHATSAPP: { value: INVOICE_ACTIONS.SAVE_AND_WHATSAPP, label: "Save & Whatsapp" },
  PRINT_AND_WHATSAPP: { value: INVOICE_ACTIONS.PRINT_AND_WHATSAPP, label: "Print & Whatsapp" },
  PAYMENT: { value: INVOICE_ACTIONS.PAYMENT, label: "Payment" },
  WITH_KOT: { value: INVOICE_ACTIONS.WITH_KOT, label: "Invoice with Kot" },
};

export const INVOICE_ACTION_BUTTON_LABELS = {
  PRINT: "Print (F4)",
  SAVE: "Save (F4)",
  SAVE_AND_WHATSAPP: "Save & WhatsApp (F4)",
  PRINT_AND_WHATSAPP: "Print & WhatsApp (F4)",
  SHARE: "Share (F4)",
  WITH_KOT: "Invoice with KOT (F4)",
  PAYMENT: "Payment (F4)",
};

export const SELECT_FIELD_CONFIGS = [
  {
    label: "Invoice display Rate",
    key: "invoiceDisplayRate",
    options: INVOICE_DISPLAY_OPTIONS,
  },
  {
    label: "Stock Availability Check",
    key: "preventNegativeStock",
    options: STOCK_CHECK_OPTIONS,
  },
  {
    label: "Add to cart option",
    key: "addToCart",
    options: ADD_TO_CART_OPTIONS,
  },
  {
    label: "KOT split options",
    key: "kotSplitOptions",
    options: KOT_SPLIT_OPTIONS,
  },
  {
    label: "Default invoice action",
    key: "defaultInvoiceAction",
    options: DEFAULT_INVOICE_ACTION_OPTIONS,
  },
];

export const PAYMENT_TYPES = {
  SERVICE: "SERVICE",
  PRODUCTION: "PRODUCTION",
};

export const CASHBOOK_ENTRY_TYPE = {
  SALE: "SALE",
  EXPENSE: "EXPENSE",
  CUSTOMER_PAYMENT: "CUSTOMER PAYMENT",
  BALANCE: "BALANCE",
  OPENING_BALANCE: "OPENING BALANCE",
  SALE_EDIT: "SALE EDIT",
  PAYMENT_MODE_CHANGE: "PAYMENT MODE CHANGE",
  VENDOR_PAYMENT: "VENDOR PAYMENT",
  PURCHASE: "PURCHASE",
};

export const CASHBOOK_DESCRIPTIONS = {
  SALE: "Sale",
  EXPENSE: "Expense",
  CUSTOMER_PAYMENT: "Customer Payment",
  BALANCE: "Balance",
  OPENING_BALANCE: "Opening Balance",
  SALE_EDIT: "Sale Edited",
  PAYMENT_CHANGE_TO: "Payment change to",
  PAYMENT_CHANGE_FROM: "Payment change from",
  PAYMENT_MODE_CHANGED: "Payment mode changed",
};

export const PRODUCT_TYPES = {
  INVENTORY: "INVENTORY",
  SERVICE: "SERVICE",
  PRODUCTION: "PRODUCTION",
};

export const TABLE_SELECTION_MODE = {
  SINGLE: "single",
  MULTI: "multi",
  CHANGE_TABLE: "change_table",
};

export const TABLE_STATUS = {
  AVAILABLE: "available",
  NOT_PAID: "not-paid",
  DINE_IN: "dine-in",
};

export const MERGE_LABELS = {
  TABLE: "Merge Table",
  SALES: "Merge Sales",
};

export const ALL_TABLES = "all";

export const TABLE_AREAS = {
  ALL: "all",
};

export const ITEM_DETAILS_DIALOG_TABS = {
  QUANTITY: "Quantity",
  DISCOUNT: "Discount %",
  RATE: "Rate",
  SALE_STAFF: "Sale Staff",
};

export const DEFAULT_PRODUCT_IMAGE = "https://storage.googleapis.com/sanoft-legacy-pos-images/default/default.jpg";

export const INVOICE_TARGET_TYPE = {
  IP: "IP",
  NONE: "NONE",
  COUNTER: "COUNTER",
};

export const CREDIT_LIMIT_TYPES = {
  CREDIT: "Credit",
  ADVANCE: "Advance",
};

export const SHOP_TYPES = {
  RESTAURANT: "restaurant",
  RETAIL: "retail",
};
export const SUBSCRIPTION_TYPES = {
  FREE: "free",
  BASIC: "basic",
  STANDARD: "standard",
  PREMIUM: "premium",
};

export const EVENTS = {
  SALES_UPDATED: "sales-updated",
  TERMINAL_SETTINGS_UPDATED: "terminal-settings-updated",
  SEARCH_ACTION: "search-action",
  KEY_DOWN: "key-down",
  POP_STATE: "pop-state",
  MOUSE_DOWN: "mouse-down",
  CUSTOMER_UPDATED: "customer-updated",
  VENDOR_UPDATED: "vendor-updated",
  PRODUCT_UPDATED: "product-updated",
  NEW_NOTIFICATION: "new-notification",
  ONLINE_ORDER_UPDATED: "online-order-updated",
  PRINTER_QUEUE_UPDATED: "printer-queue-updated",
  SCAN_START: "scan-start",
  EXPENSE_CREATED: "expense-created",
};

export const SEARCH_ACTION_TYPES = {
  ARROW_DOWN: "ARROW_DOWN",
  ARROW_UP: "ARROW_UP",
  ARROW_LEFT: "ARROW_LEFT",
  ARROW_RIGHT: "ARROW_RIGHT",
  ENTER: "ENTER",
  FOCUS_SEARCH: "FOCUS_SEARCH",
};

export const KEYBOARD_KEYS = {
  ARROW_DOWN: "ArrowDown",
  ARROW_UP: "ArrowUp",
  ARROW_LEFT: "ArrowLeft",
  ARROW_RIGHT: "ArrowRight",
  ENTER: "Enter",
  F1: "F1",
  F2: "F2",
  F3: "F3",
  F4: "F4",
  F5: "F5",
  F6: "F6",
  F7: "F7",
  F8: "F8",
  SLASH: "/",
  BACKSPACE: "Backspace",
  ESCAPE: "Escape",
  C_LOWER: "c",
  C_UPPER: "C",
  DOT: ".",
  MINUS: "-",
  PLUS: "+",
  EQUAL: "=",
  UNDERSCORE: "_",
  COMMA: ",",
};

export const QR_SERVER_IP_PREFIX = "SANOFT_POS_SERVER_IP:";

export const ROUND_OFF_TYPES = {
  FLOOR: "FLOOR",
  CEIL: "CEIL",
  NEAREST: "NEAREST",
};

export const SHIFT_STATUS = {
  OPEN: "OPEN",
  CLOSED: "CLOSED",
  CLOSING: "CLOSING",
};

export const SHIFT_REPORT_TYPES = {
  SALE_SUMMARY: "saleSummary",
  ITEM_SUMMARY: "itemSummary",
  SHIFT_REPORT: "shiftReport",
};

export const SHIFT_REPORT_OPTIONS = [
  { key: SHIFT_REPORT_TYPES.SALE_SUMMARY, label: "Sale Summary" },
  { key: SHIFT_REPORT_TYPES.ITEM_SUMMARY, label: "Item Summary" },
  { key: SHIFT_REPORT_TYPES.SHIFT_REPORT, label: "Shift Report" },
];

export const IGNORE_SCANNER_KEYS = ["Shift", "Control", "Alt"];
export const SCANNER_RESTRICTED_INPUTS = ["INPUT", "TEXTAREA"];

export const HTML_TAGS = {
  INPUT: "INPUT",
  TEXTAREA: "TEXTAREA",
  BUTTON: "BUTTON",
};

export const MODAL_SELECTORS =
  ".MuiDialog-root, .MuiModal-root, [class*='popUp'], [class*='popup'], [class*='Modal'], [class*='modal'], [class*='Dialog'], [class*='dialog']";

export const DEFAULT_BATCH_BARCODE_CONFIG = {
  PLU_LEN: 4,
  WEIGHT_LEN: 5,
  PRICE_LEN: 6,
};

export const CHARGE_CATEGORIES = {
  CHARGE: "CHARGE",
  DISCOUNT: "DISCOUNT",
};

export const CHARGE_CALCULATION_TYPES = {
  PERCENT: "PERCENT",
  AMOUNT: "AMOUNT",
};

export const CHARGE_APPLY_ON = {
  BASE: "BASE",
  PREV: "PREV",
};

export const CHARGE_LABELS = {
  SALE_CHARGES: "Sale charges",
  TOTAL_CHARGES: "Total charges",
};

export const REPORT_DATE_RANGES = {
  TODAY: "Today",
  YESTERDAY: "Yesterday",
  THIS_WEEK: "This Week",
  THIS_MONTH: "This Month",
  CUSTOM: "Custom",
};

export const REPORT_DATE_RANGE_OPTIONS = [
  { label: "Today", value: REPORT_DATE_RANGES.TODAY },
  { label: "Yesterday", value: REPORT_DATE_RANGES.YESTERDAY },
  { label: "This Week", value: REPORT_DATE_RANGES.THIS_WEEK },
  { label: "This Month", value: REPORT_DATE_RANGES.THIS_MONTH },
  { label: "Custom", value: REPORT_DATE_RANGES.CUSTOM },
];

export const KEYPAD_SCANNER_DEBOUNCE_MS = 250;

export const STAFF_PERMISSION = {
  CASH_BOX: "cash_box",
  REPRINT: "reprint",
  DELETE_CART: "delete_cart",
  BUY_BACK: "buy_back",
  REPORT: "report",
  PRICE: "price",
  DISCOUNT: "discount",
  ROUND_OFF: "round_off",
  PRODUCT_EDIT: "product_edit",
  SALE_EDIT: "sale_edit",
};

export const MACHINE_STATUS = {
  ONLINE: "Online",
  OFFLINE: "Offline",
};

export const UNKNOWN_IP = "Unknown";

export const PLATFORM_WEB = "WEB";

export const ORDER_QR_PROCESSING_TYPES = {
  AUTOMATIC: "AUTOMATIC",
  MANUAL: "MANUAL",
};
